<!-- A primary or secondary action. Factory-owned. Styles in kit.css.

     ONE primary per screen: solid, full width, in the thumb zone. Secondary is
     an outline in the accent's ink; quiet is text-weight. All three are at
     least `--tap` tall. The label names the action ("Add shift"), never the
     ceremony ("Submit", "OK"). -->
<template>
  <IonButton
    class="kit-action"
    :class="`kit-action--${kind}`"
    :fill="kind === 'primary' ? 'solid' : kind === 'secondary' ? 'outline' : 'clear'"
    :expand="expand ? 'block' : undefined"
    :size="kind === 'primary' ? 'large' : 'default'"
    :disabled="disabled"
  >
    <IonIcon v-if="icon" slot="start" :icon="icon" aria-hidden="true" />
    <slot>{{ label }}</slot>
  </IonButton>
</template>

<script setup>
import { IonButton, IonIcon } from '@ionic/vue';

defineProps({
  label: { type: String, default: '' },
  kind: {
    type: String,
    default: 'primary',
    validator: (v) => ['primary', 'secondary', 'quiet'].includes(v),
  },
  icon: { type: String, default: '' },
  expand: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
});
</script>
